import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IObligation, obligationsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getAccessControlModule } from '@/store/base/access-control/module';
import { getSearchModule } from '@/store/base/search/module';
import { type IObligationState } from '@/store/obligation-module/types';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

const OBLIGATION_MODULE = 'obligation';

const state: IObligationState = {
    responsibilities: {}
};

const dataObjectModule = getDataObjectsModule<IObligation>(obligationsManager);
const searchModule = getSearchModule<IObligation>(obligationsManager);
const accessControlModule = getAccessControlModule<IObligation>(obligationsManager);

const obligationModuleInstance = merge<unknown>(dataObjectModule, searchModule, accessControlModule, { state, actions, getters, mutations });
store.registerModule(OBLIGATION_MODULE, obligationModuleInstance);

export { OBLIGATION_MODULE };
